<template>
<b-dropdown right no-caret>
  <template slot="button-content">
      <img src="static/img/assets/edit.png">
      <!-- 表示順選択 -->
  </template>
  <b-dropdown-item @click="onClickDeleteFollowing">{{$t('deleteStr')}}</b-dropdown-item>
  <!-- <b-dropdown-item ></b-dropdown-item> -->
</b-dropdown>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'NoticeDropDown',
  props: {
    id: String,
    type: String
  },
  data () {
    return {
    }
  },
  computed: {
    getTargetObject: function () {
      return this.targetItem
    },
    targetItem: function () {
      return {targetId: this.id, targetType: this.type}
    }
  },
  methods: {
    ...mapActions({
      removeFollowing: 'REMOVE_FOLLOWING'
    }),
    onClickDeleteFollowing: function () {
      const $t = this.$t
      this.$swal({
        // sweetAlartの処理
        title: $t('popTitleStrType'),
        text: $t('doDeleteStr'),
        showCancelButton: true,
        cancelButtonColor: '#f64846',
        type: 'warning',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        reverseButtons: false,
        animation: false,
        customClass: 'animated fadeInUp',
        // customClass: 'animated flipInX',
        width: '35rem',
        position: 'center',
        // toast: true,
        allowOutsideClick: false,
        padding: '2rem'
        // timer: 4000
      }).then((result) => {
        if (result.value) {
          // okが押下されたら
          this.removeFollowing(this.getTargetObject)
          this.$swal({
            title: $t('compDeleteStr'),
            type: 'success',
            animation: false,
            customClass: 'animated fadeInUp',
            // customClass: 'animated flipInX',
            width: '35rem',
            position: 'center',
            // toast: true,
            padding: '2rem',
            timer: 3000
          })
        } else {
          // cancelが押下されたら
          console.log('false')
        }
      })
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Notice/NoticeDropDown.vue